module.exports = __webpack_public_path__ + "img/bg-SignUp.334c375f.png";